import { createSelector } from '@reduxjs/toolkit';
import { SiteModule } from '../../../types';
import { TermsAndConditionId } from '../../../components/paymentJourneyRedesign/types/enums';
import { SiteFacetsConfigData } from '../discovery';

export interface SiteContent {
  sections: SiteModule[];
  termsAndConditionId: TermsAndConditionId;
  details: {
    pageTitle: string;
    pageHeaderText: string;
    titleSize: string;
    showPageHeader: boolean;
    searchQueryData: SiteFacetsConfigData;
    visitId: string;
  };
}

export const selectSiteContent = createSelector(
  [(state) => state.siteContent.data as SiteContent],
  (data) => data || {},
);
